import { FieldArray } from "formik";
import { Box, TextField, IconButton, Typography } from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";


const Right = ({ values, setFieldValue }) => {
  return (
    <FieldArray
      name="right"
      render={(arrayHelpers) => (
        <Box display="flex" flexDirection="column" gap={2}>
          {values.right?.length > 0 ? (
            values.right.map((item, index) => (
              <Box
                key={index}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={2}
                alignItems="center"
              >                
                {/* Right Name */}
                <TextField
                  label="Right Name"
                  name={`right.${index}.rightName`}
                  fullWidth
                  variant="filled"
                  value={item.rightName || ""}
                  onChange={(e) =>
                    setFieldValue(`right.${index}.rightName`, e.target.value)
                  }                  
                  sx={{ gridColumn: "span 3" }}
                />

                {/* Description */}
                <TextField
                  label="Description"
                  name={`right.${index}.description`}
                  fullWidth
                  variant="filled"
                  value={item.description || ""}
                  onChange={(e) =>
                    setFieldValue(`right.${index}.description`, e.target.value)
                  }                  
                  sx={{ gridColumn: "span 8" }}
                />

                {/* Remove */}
                <Box sx={{ gridColumn: "span 1", textAlign: "center" }}>
                  <IconButton 
                    size="large"
                    onClick={() => arrayHelpers.remove(index)} 
                  >
                    <RemoveCircle color="error" />
                  </IconButton>
                </Box>
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No right added.
            </Typography>
          )}

          {/* Add button */}
          <Box>
            <IconButton
              aria-label="add-item"
              size="large"
              color="primary"
              onClick={() =>
                arrayHelpers.push({
                  rightName: "",
                  description: "",
                })
              }
            >
              <AddCircle />
            </IconButton>
          </Box>
        </Box>
      )}
    />
  );
};

export default Right;
